<template>
  <div class="">
    <el-form-item :label="'分区名称' + (regionItemIndex >= 9 ? (regionItemIndex+1):'0'+(regionItemIndex+1))" class="FormWrap">
      <el-input :value="regionItemItem.regionName"
                size="small"
                disabled
                class="edit-form__input"
                placeholder=""></el-input>
      <!--<el-tag class="index" size="mini">{{regionItemIndex+1}}</el-tag>-->
    </el-form-item>
    <br>
    <el-form-item :label="'分区信息' + (regionItemIndex > 0 ? '_'+(regionItemIndex+1):'')">
      <template v-if="regionItemItem.regionDetailList">
        <el-select :value="regionItemItem.regionDetailList||[]"
                   value-key="warehouseId"
                   multiple
                   filterable
                   class="edit-form__input"
                   size="small"
                   disabled
                   style="width: 655px"
                   placeholder="请选择">
          <el-option
            v-for="item in regionItemItem.regionDetailList||[]"
            :key="item.warehouseId"
            :label="item.namec"
            :value="item">
          </el-option>
        </el-select>
<!--        <el-input :value="regionItemItem.regionDetailList.map(res=>res.namec).join(',')"-->
<!--                  size="small"-->
<!--                  disabled-->
<!--                  class="edit-form__input"-->
<!--                  placeholder=""></el-input>-->
      </template>
    </el-form-item>
    <br/>
    <div v-for="(priceDetailItem,priceDetailIndex) in regionItemItem.priceDetailList"
         :key="priceDetailIndex"
         class="goods-type-box goods-card">
      <template v-if="visibleGoodsType">
        <el-form-item label="可走货物类型">
          <el-select :value="priceDetailItem.goodsTypeList||[]"
                     value-key="id"
                     multiple
                     filterable
                     disabled
                     class="edit-form__input"
                     size="small"
                     style="width: 646px"
                     placeholder="请选择">
            <el-option
              v-for="item in priceDetailItem.goodsTypeList||[]"
              :key="item.id"
              :label="item.goodsTypeName"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <br />
      </template>

      <template v-if="isShowRatioSetting">
        <el-form-item label="计费单位">
          <el-input class="edit-form__input" disabled :value="regionItemItem.chargeType"></el-input>
        </el-form-item>
        <el-form-item :label="regionItemItem.chargeType === 'KG' ? '体积重比率' : '重量转换'">
          <el-input
            class="edit-form__input"
            :value="regionItemItem.chargeType === 'KG' ? priceDetailItem.volumeWeightRatio : priceDetailItem.weightVolumeRatio"
            disabled></el-input>
        </el-form-item>
        <br />
      </template>

      <el-form-item label="是否支持单询">
        <el-input class="edit-form__input"
                  :value="priceDetailItem.isNeedInquiry ? '是' : '否'"
                  disabled></el-input>
        <!--<el-radio-group
          v-model="priceDetailItem.isNeedInquiry"
          disabled
          size="small"
        >
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>-->
      </el-form-item>
      <el-form-item label="专线api对接渠道代码" v-if="isSupportMultiChannel">
        <el-input v-model="priceDetailItem.channelCode"
                  disabled
                  size="small"
                  class="edit-form__input"
                  placeholder="请输入"></el-input>
      </el-form-item>
    </div>


  </div>
</template>

<script>
export default {
  name: "viewRegionItem",
  props:{
    regionItemIndex:Number,
    regionItemItem:{
      type:Object,
      default:()=>({}),
    },
    visibleGoodsType:Boolean,//显示货物类型
    isSupportMultiGoodsTypePrice:Number,//是否支持多产品分类报价 0>false 1>true
    isSupportMultiChannel:Boolean,//是否多渠道
    // 是否显示分区设置计费转换系数
    isShowRatioSetting: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.FormWrap {
  position: relative;
  .index {
    position: absolute;
    left: -30px;
    top: 10px;
  }
}
.goods-type-box{
  margin-left: 20px;
  padding: 10px 0;
  //border-top: 1px solid #eee;
  & + & {
  }
}
.goods-card {
  margin-top: 10px;
  padding: 10px 20px 0;
  background: #F3F3F3;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/viewDetails/viewRegionItem.vue